var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoCircle = function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.125a4.875 4.875 0 1 1 0 9.75 4.875 4.875 0 0 1 0-9.75M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12m-.937-4.125a.56.56 0 0 0-.563.563c0 .311.25.562.563.562h1.875a.561.561 0 1 0 0-1.125H7.75V6.813a.56.56 0 0 0-.562-.563H6.063a.56.56 0 0 0-.563.563c0 .311.25.562.563.562h.562v1.5zM7 5.5A.75.75 0 1 0 7 4a.75.75 0 0 0 0 1.5"
  })));
};
export default SvgInfoCircle;